// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { systemApi } from '../apis/system.api';

// action
import { actions } from '../actions/system.action';
import { ReqCreateSystem, ReqUpdateSystem, ResSystems } from '../models/system.model';
import { ResultBaseProps } from 'modules/common';

export const fetchMainSystems = createAsyncThunk<ResSystems, void>(
  actions.GET_MAIN_SYSTEM_LIST,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.getSystems(1);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchSystems = createAsyncThunk<ResSystems, number | string>(
  actions.GET_SYSTEM_LIST,
  async (clsCd, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.getSystems(clsCd);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/** 직책 조회 */
export const getDesignations = createAsyncThunk<ResSystems, void>(
  actions.GET_DESIGNATION_LIST,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.getSystems(2);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/** 공종 조회 */
export const getDisciplines = createAsyncThunk<ResSystems, void>(
  actions.GET_DISCIPLINE_LIST,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.getSystems(3);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createSystem = createAsyncThunk<ResultBaseProps, ReqCreateSystem>(
  actions.POST_SYSTEM,
  async (request, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.createSystem(request);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSystem = createAsyncThunk<ResultBaseProps, ReqUpdateSystem>(
  actions.UPDATE_SYSTEM,
  async (request, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.updateSystem(request);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSystem = createAsyncThunk<ResultBaseProps, string>(
  actions.DELETE_SYSTEM,
  async (systemId, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await systemApi.deleteSystem(systemId);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
